import React, { useEffect, useState } from 'react';
import { Lock, ShieldCheck, Zap } from 'lucide-react';
export function HeroSection() {
  const [particles, setParticles] = useState<{
    id: number;
    left: string;
    size: number;
    delay: string;
    duration: string;
  }[]>([]);
  useEffect(() => {
    // Generate random particles
    const newParticles = Array.from({
      length: 20
    }).map((_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      size: Math.random() * 4 + 2,
      delay: `${Math.random() * 5}s`,
      duration: `${Math.random() * 10 + 10}s`
    }));
    setParticles(newParticles);
  }, []);
  return <section className="relative w-full min-h-[90vh] bg-gradient-to-b from-navy to-[#1a2f5a] overflow-hidden flex items-center pt-12 pb-20" data-id="element-98">
      {/* Grid Overlay */}
      <div className="absolute inset-0 bg-grid-pattern opacity-5" data-id="element-99"></div>

      {/* Particles */}
      {particles.map(p => <div key={p.id} className="absolute bottom-0 rounded-full bg-gold animate-particle-float" style={{
      left: p.left,
      width: `${p.size}px`,
      height: `${p.size}px`,
      animationDelay: p.delay,
      animationDuration: p.duration
    }} data-id="element-100" />)}

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-101">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12" data-id="element-102">
          {/* Left Content */}
          <div className="flex-1 text-center lg:text-left animate-fade-in-up" data-id="element-103">
            <div className="inline-block mb-6 px-4 py-1.5 rounded-full border border-gold/50 bg-gold/10 backdrop-blur-sm" data-id="element-104">
              <span className="font-montserrat font-bold text-gold text-xs sm:text-sm tracking-wider" data-id="element-105">
                🎓 PARA DOCENTES DE ARGENTINA
              </span>
            </div>

            <h1 className="font-playfair font-bold text-4xl sm:text-5xl lg:text-[58px] leading-[1.1] text-white mb-6" data-id="element-106">
              Dejá de Comprar{' '}
              <span className="text-gold" data-id="element-107">PDFs que No te Sirven</span> para Nada
            </h1>

            <p className="font-inter text-lg sm:text-[22px] leading-relaxed text-[#A8B2D8] mb-10 max-w-[700px] mx-auto lg:mx-0" data-id="element-108">
              Aprendé a Crear tu Propio Material con IA en 10 Minutos. Para
              Siempre. Sin Volver a Gastar un Centavo en Otros.
            </p>

            <div className="flex flex-col items-center lg:items-start" data-id="element-109">
              <a href="#checkout" className="w-full sm:w-auto inline-block text-center bg-gold text-navy font-montserrat font-extrabold text-base sm:text-lg py-5 px-8 sm:px-12 rounded-lg shadow-[0_8px_32px_rgba(245,166,35,0.4)] hover:scale-105 hover:bg-[#ffb43a] transition-all duration-300 mb-6" data-id="element-110">
                QUIERO MI INDEPENDENCIA DOCENTE →
              </a>

              <div className="flex flex-wrap justify-center lg:justify-start gap-4 sm:gap-6 text-sm text-[#A8B2D8] font-inter" data-id="element-111">
                <div className="flex items-center gap-1.5" data-id="element-112">
                  <Lock size={16} data-id="element-113" />
                  <span data-id="element-114">Pago 100% Seguro</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-115">
                  <ShieldCheck size={16} data-id="element-116" />
                  <span data-id="element-117">Garantía de 7 días</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-118">
                  <Zap size={16} data-id="element-119" />
                  <span data-id="element-120">Acceso Inmediato</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Content - 3D Book Mockup */}
          <div className="flex-1 w-full max-w-md lg:max-w-none flex justify-center lg:justify-end animate-fade-in-up" style={{
          animationDelay: '0.2s'
        }} data-id="element-121">
            <div className="relative animate-float w-64 sm:w-80" data-id="element-122">
              {/* Book Shadow */}
              <div className="absolute -bottom-8 left-1/2 -translate-x-1/2 w-3/4 h-8 bg-gold/30 blur-xl rounded-full" data-id="element-123"></div>

              {/* Book Cover Image */}
              <img src="https://cdn.magicpatterns.com/uploads/aL7D49DHrhG3zbFqTRNDQq/ChatGPT_Image_1_mar_2026,_02_21_01.png" alt="IA Práctica para Docentes - Manual Completo" className="w-full h-auto rounded-lg shadow-2xl drop-shadow-[0_20px_40px_rgba(245,166,35,0.25)]" data-id="element-124" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}